import { string } from 'prop-types';
import React from 'react';
import PrintButton from 'components/PrintButton';

// Get props for print version. Note, this is an interim solution until we have
// standalone recipes
const getPrintProps = props => {
  // Keys to keep
  const keys = [
    'description',
    'title',
    'makes',
    'serves',
    'notes',
    'cookTime',
    'prepTime',
    'imageUrl',
    'ingredientGroups',
    'instructionGroups',
    'supplyGroups',
    'servings',
    'post'
  ];
  // Return object with whitelisted keys
  return Object.entries(props).reduce((p, [key, value]) => {
    if (keys.includes(key)) {
      return { ...p, ...{ [key]: value } };
    }
    return p;
  }, {});
};

function RecipePrintButton(props) {
  const { placement, title } = props;
  return (
    <PrintButton
      type="recipe"
      title={title}
      destination="Recipe"
      item={getPrintProps(props)}
      placement={placement}
    />
  );
}

RecipePrintButton.defaultProps = {
  placement: undefined
};

RecipePrintButton.propTypes = {
  placement: string,
  title: string.isRequired
};

export default RecipePrintButton;
